import MABAA030 from '../../pages/Memember/MABAA030';
import MABAA031 from '../../pages/Memember/MABAA031';
import MABAA040 from '../../pages/Memember/MABAA040';
import MABAA050 from '../../pages/Memember/MABAA050';
import MABAA060 from '../../pages/Memember/MABAA060';
import MABAA061 from '../../pages/Memember/MABAA061';
import MABAA080 from '../../pages/Memember/MABAA080';
import MABAA090 from '../../pages/Memember/MABAA090';
import MABAA100 from '../../pages/Memember/MABAA100';
import MABAA110 from '../../pages/Memember/MABAA110';
import MABAA120 from '../../pages/Memember/MABAA120';

const routersSub = [
    { path: '/mabaa030-:id', element: MABAA030 },
    { path: '/mabaa031-:id', element: MABAA031 },
    { path: '/mabaa070-:id', element: MABAA030 },
    { path: '/mabaa040-:id', element: MABAA040 },
    { path: '/mabaa050-:id', element: MABAA050 },
    { path: '/mabaa060-:id', element: MABAA060 },
    { path: '/mabaa061-:id', element: MABAA061 },
    { path: '/mabaa080-:id', element: MABAA080 },
    { path: '/mabaa090-:id', element: MABAA090 },
    { path: '/mabaa100-:id', element: MABAA100 },
    { path: '/mabaa110-:id', element: MABAA110 },
    { path: '/mabaa120-:id', element: MABAA120 },
];

export default routersSub;
